import React from 'react';
import { GroupBase, GroupProps } from 'react-select';

import Checkbox from '@components/common/Checkbox';
import { THandleChange } from '@components/common/Select/Select';

import { TSelectOptionType } from '@components/common/Select/Select.types';

export const FormatGroupLabel = ({
	group,
	handleChange,
	value = [],
}: {
	group: GroupBase<GroupProps | unknown>;
	handleChange?: THandleChange;
	value?: Array<TSelectOptionType>;
}) => {
	const checkedValues = value.map((item) => item?.value);
	const isAllSelected = (group.options as Array<TSelectOptionType>).every((option) =>
		checkedValues.includes(option?.value),
	);
	const isSomeSelected = (group.options as Array<TSelectOptionType>).some((option) =>
		checkedValues.includes(option?.value),
	);
	const isIndefinite = isSomeSelected && !isAllSelected;
	const isAllValuesFixed = (group.options as Array<TSelectOptionType>).every((item) => item?.isFixed);
	const isAllValuesDisabled = (group.options as Array<TSelectOptionType>).every((item) => item?.disabled);

	const toggleAllSubcategory = () => {
		const availableOptionsInCategory = (group.options as Array<TSelectOptionType>).filter(
			(option) => !(option?.isFixed || option?.disabled),
		);
		const selectedOptionsInCategory = availableOptionsInCategory.filter((option) =>
			checkedValues.includes(option?.value),
		);
		const isAllSelected = selectedOptionsInCategory.length === availableOptionsInCategory.length;

		if (handleChange) {
			if (isAllSelected) {
				const uncheckedOptions = selectedOptionsInCategory.filter(
					(option) => !option?.isFixed && !option?.disabled,
				);

				handleChange(value.filter((option) => !uncheckedOptions.includes(option)));
			} else {
				const uncheckedOptions = availableOptionsInCategory.filter(
					(option) => !checkedValues.includes(option?.value) && !option?.isFixed && !option?.disabled,
				);

				handleChange([...value, ...uncheckedOptions]);
			}
		}
	};

	return (
		<Checkbox
			checked={isAllSelected}
			disabled={isAllValuesFixed || isAllValuesDisabled}
			isIndefinite={isIndefinite}
			isPropagation
			label={group.label}
			lineHeight={14}
			name={group.label as string}
			onChange={toggleAllSubcategory}
		/>
	);
};
